/**
 * Strip tags from maker/product descriptions so they are safe to use as plain text
 * in meta descriptions and JSON-LD, where markup would be rendered literally.
 *
 * This is for *text extraction*, not sanitisation — never use it to make untrusted
 * HTML safe to inject.
 */
export function stripHtml(value: string | null | undefined): string {
  if (!value) return "";
  return value
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/\s+/g, " ")
    .trim();
}
